import { ConnectGlobalMessage } from 'components/GlobalMessage';
import ConnectGlobalModal from 'components/GlobalModal/ConnectGlobalModal';
import ConnectStickyAlert from 'components/StickyAlert/ConnectStickyAlert';
import ErrorBoundary from 'components/ErrorBoundary';
import { LiveChatAnchor } from 'components/LiveChat';
import GlobalLayout from 'components/GlobalLayout';

const App = ({ children }) => (
  <ErrorBoundary>
    <ConnectGlobalMessage />
    <GlobalLayout>{children}</GlobalLayout>
    <LiveChatAnchor />
    <ConnectGlobalModal />
    <ConnectStickyAlert />
  </ErrorBoundary>
);

export default App;
